import { SettingsModels } from './settings.model';

export namespace UserModels {
  export interface UserBaseDocument {
    email: string;
    phone?: string;
    firstname: string;
    lastname: string;
    authProviderId: string;
    edges?: string[];
    created_at: string;
    updated_at: string;
    roles: string[];
    activeOrg?: string;
    settings?: SettingsModels.Settings;
    identities: Identity[];
    timezone?: string;
    lastLogin?: number;
    isPhoneVerified?: boolean;
    externalRoles?: string[];
    isEnterpriseUser?: boolean;
    g2Reminder?: number;
    g2DontAskAgain?: boolean;
    twilioPtt?: TwilioPttDetails;
    vmPlayback?: VmPlaybackDetails;
  }

  export interface UserDocument extends UserBaseDocument {
    _id: string;
  }

  export interface UpdateUserProfileData {
    firstname?: string;
    lastname?: string;
    settings?: SettingsModels.Settings;
    activeOrg?: string;
    timezone?: string;
    phone?: string;
  }

  export interface UpdateUserProfileRequest {
    data: UpdateUserProfileData;
  }

  export enum Role {
    DEVELOPER = 'developer',
    SALES = 'sales',
    DEVTEAM = 'devteam',
    USER = 'user',
    OPERATOR = 'operator',
    PLAYBACK_ADMIN = 'playback-admin',
    PARTNER = 'partner',
  }

  export enum RolePermissionBehavior {
    COMBINED,
    SSO_ONLY,
    INTERNAL_ONLY,
  }

  export const rolePermissionMap: Record<RolePermissionBehavior, string> = {
    [RolePermissionBehavior.COMBINED]: 'ROLE_PERMISSIONS_STRATEGY.COMBINED',
    [RolePermissionBehavior.SSO_ONLY]: 'ROLE_PERMISSIONS_STRATEGY.SSO_ONLY',
    [RolePermissionBehavior.INTERNAL_ONLY]:
      'ROLE_PERMISSIONS_STRATEGY.INTERNAL_ONLY',
  };

  export const rolePermissionTooltipMap: Record<
    RolePermissionBehavior,
    string
  > = {
    [RolePermissionBehavior.COMBINED]:
      'ROLE_PERMISSIONS_STRATEGY.TOOLTIPS.COMBINED',
    [RolePermissionBehavior.SSO_ONLY]:
      'ROLE_PERMISSIONS_STRATEGY.TOOLTIPS.SSO_ONLY',
    [RolePermissionBehavior.INTERNAL_ONLY]:
      'ROLE_PERMISSIONS_STRATEGY.TOOLTIPS.INTERNAL_ONLY',
  };

  export interface TwilioPttDetails {
    identity: string;
    token: string;
    expiresAt: number;
  }

  export interface VmPlaybackDetails {
    token: string;
    expiresAt: number;
  }

  export interface Identity {
    user_id: string;
    provider: string;
    connection: string;
    isSocial: boolean;
  }

  export interface LogoutParams {
    msg?: string;
    code?: string;
    redirectUrl?: string;
  }
}
